import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { useAppStore } from '@/store/useAppStore';
import { getUnacceptedContentPolicy } from '@/utils/onboardingUtils';

export const Route = createFileRoute('/creator/apply')({
  beforeLoad: async ({ context: { auth }, location }) => {
    if (auth?.isContentCreator) {
      const { legalAcceptanceStatuses } = useAppStore.getState();
      const isContentPolicyAcceptanceRoute = location.pathname === '/creator/apply/content-policy';

      if (isContentPolicyAcceptanceRoute && getUnacceptedContentPolicy(legalAcceptanceStatuses)) {
        return;
      }

      throw redirect({
        to: '/creator/dashboard',
      });
    }
  },
  component: Outlet,
});
